module.exports = __webpack_public_path__ + "media/images/mieux-gerer-mon-stress-8ecd5b4035212d428accd95cc2ab2fdc.svg";